__turbopack_context__.v({
  "hamburger": "MobileMenuButton-module-scss-module__d9Vn_G__hamburger",
  "hamburger_line": "MobileMenuButton-module-scss-module__d9Vn_G__hamburger_line",
  "is_open": "MobileMenuButton-module-scss-module__d9Vn_G__is_open",
  "mobile_menu_button": "MobileMenuButton-module-scss-module__d9Vn_G__mobile_menu_button",
});
